// {
//     "Id": "41337",
//     "Tax": 0,
//     "Name": "Cdtfa Tire Fee",
//     "Type": "Upfront",
//     "Amount": 7,
//     "TaxRate": 0,
//     "TitleId": "41337",
//     "Category": "Registration",
//     "TaxIndex": 0,
//     "FormsData": {
//     "Name": "TIRE_FEE",
//         "Category": "Other",
//         "VendorName": "",
//         "DisplayName": ""
// },
//     "CostPerDay": 0,
//     "SourceType": null,
//     "SubTitleId": null,
//     "UpfrontTax": 0,
//     "RollupTitle": "",
//     "FinanceTaxes": "No",
//     "TaxDeduction": "No",
//     "CostPerPeriod": 0.22,
//     "RollupTitleId": "",
//     "CapitalizedTax": 0,
//     "DescriptionType": "RegularFee",
//     "GranularityLevel": "Standalone",
//     "CCRPortionFeeTaxed": "No",
//     "PaidOutsideOfClosingTax": 0
// }

export const PAID_OUTSIDE_OF_CLOSING_TYPE = 'PaidOutsideOfClosing'
export const UPFRONT_TYPE = 'Upfront'
export const FINANCED_TYPE = 'Financed'

export const DOC_FEE_NAME = 'Doc Fee'

// Display only: a deal with no Doc Fee shows a read-only $0 one. Never send it.
export const withDocFee = (fees) => {
    if (fees.some(f => f.name === DOC_FEE_NAME)) return fees
    const docFee = {
        id: 'doc-fee', name: DOC_FEE_NAME, amount: '0',
        is_capped: false, is_taxed: false, is_tax_capped: false, is_editable: false,
    }
    return [docFee, ...fees]
}

class FeeHelper {
    constructor(fee) {
        this.fee = fee
    }

    name = () => this.fee.Name

    amount = () => this.fee.Amount

    type = () => this.fee.Type

    absoluteAmount = () => Math.abs(this.amount())

    negativeAmount = () => -this.absoluteAmount()

    id = () => this.fee['Id']

    collateralId = () => this.fee['CollateralID']

    titleId = () => this.fee['TitleId']

    uniqueId = (idx) => {
        const uniqueId = this.collateralId() || idx

        return `${this.id()}-${this.titleId()}-${uniqueId}`
    }

    isSelected = () => this.type() !== PAID_OUTSIDE_OF_CLOSING_TYPE

    isFinanced = () => this.type() === 'Financed'

    isUpfront = () => this.type() === 'Upfront'

}

export default FeeHelper